/*
 * @FilePath: index.js
 * @Author: chenwei
 * @Date: 2022-07-07 09:18:16
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-11 19:29:51
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
import {get,post} from '@/utils/request'
import {proxyHeader} from "@/utils/config"

//根据用户获取订单列表
export const getOrderList = p => get(proxyHeader+'service/order-service/order/list', p);

//提交申请生成订单
export const createOneOrder = p => post(proxyHeader+'service/order-service/order/applyOrder', p);

//根据订单号查询订单
export const getOrderStatusById = p => get(proxyHeader+'service/order-service/order/info', p);

//根据订单编号查询订单项
export const getOrderProductById = p => get(proxyHeader+'service/order-service/order-item/list', p);

//获取订单状态
export const getOrderStatusList = (p) => get(proxyHeader+'service/common-service/sys-dic-item/likeByDicCodeCachelist', p);

//查询订单状态列表
export const getOrderStatusLTimeList = (p) => get(proxyHeader+'service/order-service/order-status/getByOrderId', p);

//点击下载获取ftp信息
export const getOrderFtpInfo = (p) => get(proxyHeader+'service/order-service/order/getOrderFTP', p);

//批量删除订单
export const deleteOrders = (p) => post(proxyHeader+'service/order-service/order/deleteOrders', p);

//批量删除订单
export const downloadAll = (p) => get(proxyHeader+'service/order-service/order/downloadAll', p);

//批量删除订单
export const getDownloadUrl = (p) => get(proxyHeader+'service/order-service/order/getDownloadUrl', p);
